import { FolderOpenTwoTone, PlusOutlined } from '@ant-design/icons';
import { Row } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { useState } from "react";
import { Button, Col, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { idQuyDauTu } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { DonViResponse } from '../../models/donvi/DonVi';
import ContainerDepartment from '../../modules/department/ContainerDepartment';
import { xoaDonVi } from '../../services/donvi';

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {

                key: _item?.id,
                title: _item?.ten,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
                children: convertDataTreeView(_item?.children)
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const DanhSachDonVi = () => {
    const [openModalXoa, setOpenModalXoa] = useState<number>(-1);
    const [reloadTree, setReloadTree] = useState<boolean>(false);
    const [donViShow, setDonViShow] = useState<DonViResponse | null | undefined>(null);
    const menu: any = menuHelper.checkMultiPermission([Links.DonVi.Xoa]);
    const onSelectDepartment = (e: any) => {
        setDonViShow(e);
    };

    const xoa = async (id: number) => {
        try {
            setReloadTree(false);
            let temp = await xoaDonVi(id);
            setOpenModalXoa(-1);
            if (temp) {
                setReloadTree(true);
                toast.success('Xóa đơn vị thành công!');
                setDonViShow(null);
            } else {
                toast.error('Xóa đơn vị không thành công!');
            }
        }
        catch (error: any) {
            setOpenModalXoa(-1);
            toast.error('Xóa đơn vị không thành công!');
        };
    };

    const containerDepartmentProps = {
        showHeader: true,
        onChange: onSelectDepartment,
        reloadTree: reloadTree,
        treeProps: {
            defaultExpandedKeys: [idQuyDauTu]
        }
    }
    return (<section>
        <Modal show={openModalXoa > -1} onHide={() => setOpenModalXoa(-1)}>
            <Modal.Header closeButton>
                <Modal.Title>Xóa đơn vị</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn xóa đơn vị <strong>{donViShow?.ten}</strong> không?
                <br />
                <strong><span className="text-red">Lưu ý:</span></strong> Sẽ xóa các đơn vị con và người dùng liên quan.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalXoa(-1)}>
                    Đóng
                </Button>
                <Button variant="danger" className="btn-sm" onClick={() => xoa(openModalXoa)}>
                    Xóa
                </Button>
            </Modal.Footer>
        </Modal>
        <ContentHeader title="Danh sách Phòng ban" />
        <Row className='form-group'>
            <Col>
                {menu[Links.DonVi.Xoa] ?
                    <Link className="hrm-btn float-right hrm-btn-warning" to={Links.DonVi.ChiTiet}><PlusOutlined rev="" />Thêm mới</Link>
                    : null}
            </Col>
        </Row>
        <Row>
            <Col>
                <ContainerDepartment {...containerDepartmentProps} >
                </ContainerDepartment>
            </Col>
            <Col>
                <div className="card card-primary card-outline">
                    <div className="card-header">
                        <h3 className="card-title">Thông tin phòng ban</h3>
                    </div>
                    <div className="card-body">
                        <div>
                            <Row>
                                <Col sm="4">
                                    <label className="control-label">Mã đơn vị:</label>
                                </Col>
                                <Col sm="8">
                                    {donViShow?.ma}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="4">
                                    <label className="control-label">Tên đơn vị:</label>
                                </Col>
                                <Col sm="8">
                                    {donViShow?.ten}
                                </Col>
                            </Row>
                            <div className="row button" style={{ borderTop: "1px solid #f4f4f4", padding: "10px" }}>
                                <div className="col-sm-6">
                                    {donViShow !== null && donViShow !== undefined && menu[Links.DonVi.Xoa] ?
                                        <Button className="float-left btn btn-danger btn-sm" onClick={() => { setOpenModalXoa(donViShow?.id || 0) }} style={{ "marginLeft": "10px" }} type="button" title="Xóa đơn vị" >Xóa <i className="fas fa-trash-alt" /></Button>
                                        : null}
                                </div>{
                                    donViShow !== null && donViShow !== undefined && 
                                    <div className="col-sm-6">
                                        <Link to={Links.DonVi.ChiTiet + "?id=" + (donViShow?.id || 0)} className="float-right btn btn-info btn-sm" title="Xem chi tiết">Xem <i className="fa fa-eye" /></Link>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    </section>
    );
};

export default DanhSachDonVi;
